var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer px-4 mx-2"},[_c('div',{staticClass:"row align-items-center justify-content-lg-between"},[_c('div',{staticClass:"col-lg-6"}),_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"copyright text-center text-lg-right text-gray",domProps:{"innerHTML":_vm._s(_vm.copyright)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }